export enum DPE_DISMISSAL_REASONS {
  driver_not_at_fault = 'driver_not_at_fault',
  no_unsafe_behavior = 'no_unsafe_behavior',
  positive_behavior = 'positive_behavior',
  other = 'other',
}

export const DPE_DISMISSAL_REASONS_LABELS: Record<DPE_DISMISSAL_REASONS, string> = {
  driver_not_at_fault: $localize`The driver is not at fault`,
  no_unsafe_behavior: $localize`There is no unsafe behavior in this event`,
  positive_behavior: $localize`Recognized as positive driving behavior`,
  other: $localize`Other`,
};

export type DpeDismissalReasonType = Array<DPE_DISMISSAL_REASONS | string>;